import {Component, OnInit} from '@angular/core';
import {ProjectsService} from "../../../services/projects.service";
import {environment} from "../../../../../environments/environment";
import {CoreService} from "../../../services/core.service";

@Component({
  selector: 'app-thank-you-lead-generation',
  templateUrl: './thank-you-lead-generation.component.html',
  styleUrls: ['./thank-you-lead-generation.component.sass']
})
export class ThankYouLeadGenerationComponent {
  constructor(
    private coreService: CoreService
  ) {
    this.coreService.enableThankYouPage();
  }

}
